import { ArrowUpRight } from 'lucide-react';
import React from 'react';

export function AtellioMarketingBanner() {
  return (
    <div className="tailwind-root">
      <div className="p-4 text-fg-subtle bg-bg-emphasis text-center">
        <span className="font-semibold text-white">Atellio</span> is a talent
        management platform empowering companies to manage their own talent
        network
        <a
          href="https://atellio.com"
          className="text-white font-semibold px-2 inline-flex items-center gap-1"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn more
          <ArrowUpRight className="w-5 h-5" />
        </a>
      </div>
    </div>
  );
}
